import React from "react";

const BeginButton = ({ onClick, type, text, children }) => {
  var buttonClass = `${type}-button begin-button`;
  return (
    <button onClick={onClick} className={buttonClass}>
      {children}
      <div className="begin-button-text">{text}</div>
    </button>
  );
};

export default BeginButton;
